<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		id="ksef-send-parameters-dialog-header"
		[title]="'scenes.configuration.shared.ksef-send-parameters.dialog.title' | translate"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1-2">
						<div class="col-1">
							<ins-checkbox
								id="ksef-send-parameters-dialog-send-document-note"
								class="align--medium-top align--medium-bottom"
								[(ngModel)]="viewModel.bo.model.sendDocumentNote"
								[label]="'scenes.configuration.shared.ksef-send-parameters.dialog.form.send-document-note.label' | translate">
							</ins-checkbox>
						</div>
						<div class="col-1">
							<ins-checkbox
								id="ksef-send-parameters-dialog-send-wz-numbers"
								class="align--medium-top align--medium-bottom"
								[(ngModel)]="viewModel.bo.model.sendWzNumbers"
								[label]="'scenes.configuration.shared.ksef-send-parameters.dialog.form.send-wz-numbers.label' | translate">
							</ins-checkbox>
						</div>
					</div>
					<div class="col-1-2">
						<div class="col-1">
							<div class="display--flex">
								<ins-checkbox
									id="ksef-send-parameters-dialog-send-symbol-as-indeks"
									class="align--medium-top align--medium-bottom"
									[(ngModel)]="viewModel.bo.model.sendSymbolAsIndeks"
									[label]="'scenes.configuration.shared.ksef-send-parameters.dialog.form.send-symbol-as-indeks.label' | translate">
								</ins-checkbox>
								<div>
									<skl-icon
										[tooltip]="indeksTooltip"
										class="icon--clickable"
										color="secondary"
										shape="circle"
										name="help">
									</skl-icon>
								</div>
							</div>
						</div>
						<div class="col-1">
							<div class="display--flex">
								<ins-checkbox
									id="ksef-send-parameters-dialog-send-bar-code-as-gtin"
									class="align--medium-top align--medium-bottom"
									[(ngModel)]="viewModel.bo.model.sendBarCodeAsGTIN"
									[label]="'scenes.configuration.shared.ksef-send-parameters.dialog.form.send-bar-code-as-gtin.label' | translate">
								</ins-checkbox>
								<div>
									<skl-icon
										[tooltip]="gtinTooltip"
										class="icon--clickable"
										color="secondary"
										shape="circle"
										name="help">
									</skl-icon>
								</div>
							</div>
						</div>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.ksef-send-parameters.dialog.form.sale-pattern-send-mode.label' | translate">
							<ins-select
								display-text="label"
								id="ksef-send-parameters-dialog-document-template-send-mode"
								[converter]="salePatternSendModesConverter"
								[(ngModel)]="viewModel.bo.model.documentTemplateSendMode"
								[sklValidate]="getValidationKey('documentTemplateSendMode')">
								@for (item of salePatternSendModes; track item) {
									<ins-option
										[value]="item">
										{{item.label}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.ksef-send-parameters.dialog.form.default-document-type.label' | translate">
							<ins-select
								display-text="label"
								[converter]="documentTypesConverter"
								id="ksef-send-parameters-dialog-default-document-type"
								[(ngModel)]="viewModel.bo.model.defaultDocumentType"
								[sklValidate]="getValidationKey('defaultDocumentType')">
								@for (item of documentTypes; track item) {
									<ins-option
										[value]="item">
										{{item.label}}
									</ins-option>
								}
							</ins-select>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>

	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="ksef-send-parameters-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="ksef-send-parameters-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>
